import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

const FALLBACK = {
  site_name: "Fileuploady",
  hero_title: "Share files. Simple.",
  hero_subtitle: "Upload your files, get a link, and share them instantly.",
  cta_choose_files: "Choose files",
  upload_instructions: "Drop files here",
  no_account_text: "No account required.",
  anon_expiration_options: ["1d", "7d", "1m"],
  auth_expiration_options: ["unlimited", "1m", "7d", "1d"],
  anon_default_expiration: "1d",
  auth_default_expiration: "unlimited",
  anon_max_file_size: 2 * 1024 ** 3,
  auth_max_file_size: 5 * 1024 ** 3,
  multiple_upload_enabled: true,
  registration_enabled: true,
  abuse_reporting_enabled: true,
  feature_sections: [],
  footer_links: [],
  social_links: [],
  footer_copyright: "© {year} Fileuploady. All rights reserved.",
};

export function useSettings() {
  const query = useQuery({ queryKey: ["public-settings"], queryFn: async () => (await api.get("/settings/public")).data, staleTime: 5 * 60_000 });
  return { settings: { ...FALLBACK, ...(query.data || {}) }, ...query };
}
